import { client } from '../moovyAxiosClient'
import { GrantedVoucherDTO } from './dto'

const createPermit = async (
  guid: string | undefined,
  LisencePlateNumber: string,
  VoucherTemplate: string
) => {
  if (!guid) {
    throw new Error('UserGroup guid is missing')
  }
  const response = await client.post<GrantedVoucherDTO>(guid + '/permit', {
    LisencePlateNumber,
    VoucherTemplate,
    UserGroupRef: guid
  })
  return response.data
}

export default {
  createPermit
}
